const separator = '#------#';

export const getText = (
  variable: any,
  source: 'primary' | 'secondary' = 'primary'
): string => {
  if (!variable) {
    return '';
  }
  if (typeof variable === 'string') {
    const str = variable as string;
    if (str.indexOf(separator) > -1) {
      const split = str.split(separator);
      const obj = {
        primary: split[0],
        secondary: split[1]
      };
      return obj[source] || obj.primary;
    }
    return variable;
  }
  if (typeof variable === 'object') {
    if (Object.keys(variable).length) {
      if (variable[source]) {
        return variable[source];
      }
    }
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/utils/getText.ts